import { useTranslation } from '@jupiter/plugin-runtime/i18n';
import { REGION_NAME } from '@features/runtime/config';
import { getLocaleFormat, localeFormatTimeDayjs } from '@oec-seller/lib';

type ILocaleFormatTime = Parameters<typeof localeFormatTimeDayjs>[0];

export const useI18nTimeFormat = () => {
  const {
    i18n: { language },
  } = useTranslation();
  const tFormat = (
    time: ILocaleFormatTime['time'] | null | undefined,
    signal: ILocaleFormatTime['signal'],
  ) => {
    if (!time) {
      return '- -';
    }
    const { length } = String(time).toString();
    const timeStamp = length === 10 ? Number(time) * 1000 : Number(time);

    return localeFormatTimeDayjs({
      region: REGION_NAME,
      language,
      time: timeStamp,
      signal,
    });
  };

  const getFormat = (signal: ILocaleFormatTime['signal']) => {
    return getLocaleFormat({ region: REGION_NAME, language, signal });
  };

  return { tFormat, localeFormatTimeDayjs, getFormat };
};
